const RETAIL_ADMIN_ROLE = 'retail_admin';

const RETAIL_TEAM = 'retail';

export {RETAIL_ADMIN_ROLE, RETAIL_TEAM};